module.exports = __webpack_public_path__ + "static/media/snatta.06ebce5e.mp3";